import { Link } from 'react-router';

import type { PublicPracticeSongCard } from './types';

const DIFFICULTY_LABELS: Record<string, string> = {
  beginner: '입문',
  intermediate: '중급',
  advanced: '고급',
};

export function publicPracticeDifficultyLabel(difficulty: string): string {
  return DIFFICULTY_LABELS[difficulty] ?? difficulty;
}

export default function PublicPracticeSongList({
  songs,
}: {
  songs: PublicPracticeSongCard[];
}) {
  return (
    <ol
      className="public-practice-song-list"
      aria-label="공개 보컬 연습곡 목록"
    >
      {songs.map((song) => (
        <li key={song.song_key}>
          <article className="public-practice-song-card">
            <h2>
              <Link to={song.hub_path}>{song.title}</Link>
            </h2>
            <p className="public-practice-song-card__artist">
              <Link to={`/ko/artists/${song.artist_slug}`}>
                {song.artist_name}
              </Link>
            </p>
            <dl
              className="public-practice-song-card__facts"
              aria-label={`${song.title} 연습 정보`}
            >
              <div>
                <dt>발표 연도</dt>
                <dd>{song.release_year}</dd>
              </div>
              <div>
                <dt>장르</dt>
                <dd>{song.genre}</dd>
              </div>
              <div>
                <dt>난이도</dt>
                <dd>{publicPracticeDifficultyLabel(song.difficulty)}</dd>
              </div>
              <div>
                <dt>보컬 음역</dt>
                <dd>{song.vocal_range}</dd>
              </div>
              <div className="public-practice-song-card__version">
                <dt>버전</dt>
                <dd>{song.version_label}</dd>
              </div>
            </dl>
            <p className="public-practice-song-card__summary">
              {song.hero_summary}
            </p>
          </article>
        </li>
      ))}
    </ol>
  );
}
